<script setup>
import { useI18n } from 'vue-i18n';
import { computed, onMounted, useSlots, watch } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BasicCard from '@/components/Cards/BasicCard.vue';
import { mixins } from '@/Mixins/mixin.js';
import packageJson from '/package.json';

const { locale, availableLocales } = useI18n({ useScope: 'global' });

const emits = defineEmits(['leftCorner', 'rightCorner', 'topCorner']);
const appVersion = computed(() => packageJson.version);

defineProps({
  leftBtnIcon: String,
  rightBtnIcon: String,
  leftBtnClass: String,
  rightBtnClass: String,
  topBtnIcon: String,
  topBtnClass: String,
});

onMounted(() => {
  mixins.defaultDarkModeCheck();
});

// Watch for locale changes and save to localStorage
watch(locale, (newLocale) => {
  localStorage.setItem('lang', newLocale);
});

const slots = useSlots();

// On component mount, set locale from localStorage
onMounted(() => {
  const savedLocale = localStorage.getItem('lang');
  if (savedLocale) {
    locale.value = savedLocale;
  }
});
</script>

<template>
  <div :class="`bg-island layout-bg-center p-8 overflow-hidden`">
    <slot />

    <!-- The Footer -->
    <div class="flex items-center justify-center flex-col mt-8">
      <slot name="aboveFooter" />
      <BasicCard color="glass-bright dark:glass-dark">
        <div class="text-sm text-center text-white">
          <slot name="footer" />
          <p>sa-pc-ujian v{{ appVersion }} - SuperApp PPSDM Migas &copy; 2026 PPSDM Migas</p>
        </div>
      </BasicCard>
    </div>

    <div v-if="leftBtnIcon" class="corner-btn-container left">
      <div class="corner-left-btn" :class="leftBtnClass" @click="emits('leftCorner')">
        <font-awesome-icon :icon="leftBtnIcon" size="lg" class="absolute z-[6] text-white" />
      </div>
    </div>

    <div v-if="rightBtnIcon" class="corner-btn-container right">
      <div class="corner-right-btn" :class="rightBtnClass" @click="emits('rightCorner')">
        <font-awesome-icon :icon="rightBtnIcon" size="lg" class="absolute z-[6] text-white" />
      </div>
    </div>

    <div v-if="topBtnIcon || slots.topBtn" class="corner-btn-container top">
      <div class="corner-top-btn" :class="topBtnClass" @click="emits('topCorner')">
        <div v-if="slots.topBtn" class="absolute z-[6] text-white">
          <slot name="topBtn" />
        </div>
        <font-awesome-icon v-else :icon="topBtnIcon" size="lg" class="absolute z-[6] text-white" />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
